import { match, P } from 'ts-pattern';
import { zfd } from 'zod-form-data';
import api from '~/utils/api';
import { makeCrewAction, makeCrewLoader, redirect } from '~/utils/routing';
import { orderEditActionSchema } from '~/utils/schemas';

export const actionFormKey = 'order-edit-action';

const schema = zfd.formData({
  [actionFormKey]: zfd.json(orderEditActionSchema),
});

export const { action, useActionResult } = makeCrewAction(
  ({ formData }, appStore) =>
    match(schema.safeParse(formData))
      .with({ success: false }, () => redirect('../'))
      .with({ success: true, data: P.select() }, (data) => {
        appStore.dispatch(
          appStore.actions.orderEdit.assignAction(data[actionFormKey]),
        );

        return redirect(`../edit/stage`);
      })
      .exhaustive(),
);

export const { loader, useLoaderData } = makeCrewLoader(({ context }) =>
  api
    .startOrderEdit({
      params: {
        storefrontId: context.settings.storefrontId,
        storeOrderId: context.order.id,
      },
    })
    .then((data) => ({
      orderEditActions: data,
      orderEditExpiredDescriptionText:
        context.settings.theme.orderEditExpiredDescriptionText,
    })),
);
